/**
 * Network Status Checker Utility
 * Monitors heartbeat values from Redux store and triggers offline handling
 * when no new heartbeat is received within the expected timeframe
 */

class NetworkStatusChecker {
  constructor() {
    this.checkInterval = null;
    this.lastHeartbeatValue = null;
    this.onOfflineCallback = null;
    this.getState = null;
    this.isChecking = false;
  }

  /**
   * Start monitoring network status
   * @param {Object} store - Redux store instance
   * @param {Function} onOffline - Callback to trigger when network goes offline
   */
  startMonitoring(store, onOffline) {
    if (this.isChecking) {
      return;
    }

    this.onOfflineCallback = onOffline;
    this.getState = () => store.getState().events.heartbeat;
    this.lastHeartbeatValue = this.getState();
    this.isChecking = true;

    this.checkInterval = setInterval(() => {
      const currentHeartbeat = this.getState();

      if (currentHeartbeat === this.lastHeartbeatValue) {
        this.onOfflineCallback();
        this.stopMonitoring();
      } else {
        this.lastHeartbeatValue = currentHeartbeat;
      }
    }, 20000);
  }

  /**
   * Stop monitoring network status
   */
  stopMonitoring() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
      this.checkInterval = null;
    }
    this.isChecking = false;
    this.lastHeartbeatValue = null;
  }

  /**
   * Reset the checker (useful when reconnecting)
   */
  reset() {
    this.lastHeartbeatValue = null;
  }

  /**
   * Check if monitoring is currently active
   */
  isActive() {
    return this.isChecking;
  }
}

export const networkStatusChecker = new NetworkStatusChecker();
export default networkStatusChecker;
